import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Empty the cart API Call
 * @returns {Promise<Object>} - Response data from the API
 */
export const emptyCart = async (customerId) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.EMPTY_CART, {
      customer_id: customerId,
    });
    return response.data; // Return the response data
  } catch (error) {
    handleApiError(error); // Handle error with the common handler
    throw error; // Propagate the error
  }
};
